import { useEffect } from "react";
import { useSelector } from "react-redux";
import { methodGetReasonLib } from "../../api/apicraft/api";
import { GetDaily } from "../../api/Summary";
import { GetTags } from "../../api/Tag";
import { UserDaily } from "../../model/statistic/Daily";
import { BackendTagBank, TagBank } from "../../model/TagData";
import { ReasonLib } from "../../model/user/reason";
import { useAppDispatch } from "../hooks";
import { actionSetDaily, actionSetReasonLib, actionSetTagBank } from "./reducer";
import { selectReasonLib, selectTagBank } from "./selector";

export function useEnsureTagBank(): TagBank {
    const dispatch = useAppDispatch();
    const bank = useSelector(selectTagBank);
    useEffect(() => {
        if (bank.is_backend_data) {
            return;
        }
        GetTags({
            afterSuccess: (b: BackendTagBank) => {
                dispatch(actionSetTagBank(b));
            },
            dispatch,
        });
    }, [dispatch, bank]);

    return bank;
}

/**
 * @deprecated use useEnsureTagBank instead
 */
export function ensureTagBank(bank: TagBank, dispatch: any) {
    if (bank.is_backend_data) {
        return;
    }
    GetTags({
        afterSuccess: (b: BackendTagBank) => {
            dispatch(actionSetTagBank(b));
        },
        dispatch,
    });
}

export function ensureDaily(daily: UserDaily, dispatch: any) {
    if (daily.is_backend_data) {
        return;
    }
    GetDaily({
        afterSuccess: (d: UserDaily) => {
            dispatch(actionSetDaily(d));
        },
        dispatch,
    });
}

export function useEnsureReasonLib(): ReasonLib {
    const dispatch = useAppDispatch();
    const reasonLib = useSelector(selectReasonLib);

    useEffect(() => {
        if (reasonLib.isBackendData) {
            return;
        }
        methodGetReasonLib(dispatch, {}).then((rsp) => {
            dispatch(actionSetReasonLib(rsp.reason_lib));
        });
    }, [dispatch, reasonLib]);

    return reasonLib;
}
